import React, { useEffect, useState } from 'react'
import { FieldTypes } from '../../utils/constants'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import Form from '../common/Form'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import dayjs from 'dayjs'

export default function EventReportForm({
  onSubmit,
  handleCancel,
  building,
}) {
  const classes = useStyles()

  const [values, setValues] = useState({
    startDate: dayjs().subtract(1, 'day'),
    endDate: dayjs().endOf('day'),
  })
  const [selectedBuilding, setSelectedBuilding] = useState(building)
  const [{ getApartmentsFromBuildingState }, { getApartmentsFromBuilding }] =
    useApartmentsApi()
  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()
  const [apartments, setApartments] = useState([])

  useEffect(() => {
    const fetchBuildingData = async () => {
      getBuildings()
    }
    fetchBuildingData()
  }, [])

  useEffect(() => {
    if (selectedBuilding) {
      const fetchApartmentsFromBuilding = async () => {
        getApartmentsFromBuilding(selectedBuilding.id)
      }
      fetchApartmentsFromBuilding()
    }

    setApartments([])
  }, [selectedBuilding, selectedBuilding?.id])

  const fields = [
    {
      type: FieldTypes.DatePicker,
      label: 'Fecha de inicio',
      hint: 'Fecha de inicio',
      key: 'startDate',
      // errorMessage: 'La cédula es requerida',
      numeric: false,
      withMargin: true,
      fullWidth: true,
    },
    {
      type: FieldTypes.DatePicker,
      label: 'Fecha de fin',
      hint: 'Fecha de fin',
      key: 'endDate',
      // errorMessage: 'La cédula es requerida',
      numeric: false,
      withMargin: true,
      fullWidth: true,
    },
    ...(!building
      ? [
          {
            type: FieldTypes.DoubleAutocomplete,
            autocompletes: [
              {
                label: 'Cliente',
                hint: 'Seleccione un cliente',
                errorMessage: 'El cliente es requerido',
                key: 'building',
                options: buildingsState.buildings,
                multiple: false,
                freeSolo: false,
                withMargin: true,
                disabled: values.global,
                onChange: (value) => {
                  setSelectedBuilding(value)
                  setValues({ ...values, buildingId: value.id })
                },
                required: true,
              },
              {
                label: 'Unidad',
                hint: 'Seleccione un apartamento',
                key: 'apartment',
                options: getApartmentsFromBuildingState.apartments,
                multiple: false,
                freeSolo: false,
                withMargin: true,
                disabled: values.global,
                onChange: (value) => {
                  setValues({ ...values, apartmentId: value.id })
                },
              },
            ],
          },
        ]
      : []),
    ...(building
      ? [
          {
            type: FieldTypes.Autocomplete,
            label: 'Unidad',
            hint: 'Seleccione unidad',
            key: 'apartmentId',
            options: getApartmentsFromBuildingState?.apartments?.sort((a, b) =>
              a.name.localeCompare(b.name)
            ),
            multiple: false,
            freeSolo: false,
            withMargin: true,
            onChange: (value) => {
              setValues({ ...values, apartmentId: value.id })
            },
          },
        ]
      : []),
    {
      type: FieldTypes.TextField,
      label: 'Nombre, apellido o documento de identidad',
      hint: 'Nombre, apellido o documento de identidad',
      key: 'search',
    },
  ]

  return (
    <div className={classes.paper}>
      <ListHeader bigTitle={'Exportar historial'} canCreate={false} />
      <Form
        values={values}
        setValues={setValues}
        fields={fields}
        handleSubmit={() => {
          onSubmit(values)
        }}
        handleCancel={handleCancel}
      />
    </div>
  )
}
